const t = (o) => Object.freeze(o.map((e) => ({ id: e, name: e })));
export {
  t as selectionOptionsFor
};
